import { FilterField, FilterVocabulary } from './vocabulary/vocabulary';
import { FilterLiteral, fieldPath } from './wire';

/** The root `uid` leaf, when it takes `is_any_of`: what lets a Path tree name rows by uid. */
export function uidMembershipField(vocabulary: FilterVocabulary): FilterField | undefined {
  const field = vocabulary.field(null, fieldPath('uid'));
  return field?.operators.includes('is_any_of') ? field : undefined;
}

/** `uids` as the `is_any_of` literals `field` accepts: typed uids, or plain strings. */
export function uidMembershipLiterals(
  field: FilterField,
  uids: readonly string[]
): FilterLiteral[] {
  const kind = field.literalKinds.is_any_of?.includes('uid') ? 'uid' : 'string';
  return uids.map((uid) => ({ [kind]: uid }) as FilterLiteral);
}
